import { Navigate } from 'react-router';
import _ from 'lodash';
import { LocalStorageService } from 'services';
import { User } from 'app/auth/types';
import { ReactNode } from 'react';
import { Type, Rule } from 'constants/accessControl';
import { UserClaimTypes } from 'constants/enumTypes1';

interface CanProps {
  type?: Type;
  rule?: Rule | Rule[];
  children: ReactNode;
  fallback?: ReactNode;
  redirect?: boolean;
  claims?: UserClaimTypes[];
}

const Can = ({
  type, rule, children, fallback, redirect, claims,
}: CanProps) => {
  const user = LocalStorageService.get<User>('user');

  const isSuperAdmin = user?.userClaims?.includes(UserClaimTypes.SuperAdmin);

  if (!user) {
    return false;
  }

  if (isSuperAdmin) {
    return children;
  }

  const getAvailability = (data: string) => {
    const ability = data ? data.split('.') : '';
    return user?.permissions?.[ability[0]]?.[ability[1]]?.filter((permission) => type === 'view' || _.camelCase(permission) === type).length > 0;
  };

  const fb = redirect ? <Navigate to="/notFound" replace /> : fallback;
  const noAccess = !_.isUndefined(fb) ? fb : <> </>;

  const getHasClaimAccess = () => !!(claims && user?.userClaims && _.intersection(user?.userClaims, claims).length);
  const getHasPermissionAccess = () => !!rule && (Array.isArray(rule) ? rule.some((el) => getAvailability(el)) : getAvailability(rule));

  return getHasClaimAccess() || (!claims && getHasPermissionAccess()) ? children : noAccess;
};

export default Can;
